import {GetServerSidePropsContext, NextApiRequest, NextApiResponse, NextPageContext} from 'next';

export class ContextService {
    public static req: GetServerSidePropsContext['req'] | NextApiRequest | NextPageContext['req'];
    public static res: GetServerSidePropsContext['res'] | NextApiResponse | NextPageContext['res'];
    public static ctx: GetServerSidePropsContext | NextPageContext;
}
